import BlogColor from './BlogColour.svg';
import BlogDark from './BlogDark.svg';
import BlogLight from './BlogLight.svg';
export const blog = { color: BlogColor, dark: BlogDark, light: BlogLight };
//# sourceMappingURL=index.js.map